import React from 'react';

import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

import { useMediaQuery } from 'hooks/use-media-query';

const SkeletonWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  gap: ${({ isMobile }) => (isMobile ? '0.5rem' : '1.5rem')};
  overflow: hidden;
  padding-inline-start: ${({ isMobile }) => (isMobile ? '1.2rem' : '0')};
  margin-block-end: ${({ isMobile }) => (isMobile ? '0.5rem' : '0')};
`;

export const InlineRewardsSkeleton = () => {
  const isMobile = useMediaQuery('mobile');

  const Skeletons = new Array(10)
    .fill(true)
    .map((_, index) => (
      <Skeleton
        key={index}
        height={isMobile ? '184px' : '250px'}
        width={isMobile ? '136px' : '152px'}
        style={{ borderRadius: '0.5rem' }}
      />
    ));

  return <SkeletonWrapper isMobile={isMobile}>{Skeletons}</SkeletonWrapper>;
};
